// extracted by mini-css-extract-plugin
export default {"wrap":"CategoryTab_wrap__1ohOy","allBtn":"CategoryTab_allBtn__0k5gQ","filterCategoryBtn":"CategoryTab_filterCategoryBtn__vc5Ru"};